import { render } from "./UserSettings.vue?vue&type=template&id=03f1798b&ts=true"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=03f1798b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__